import React, { useState } from 'react';
import { Stack } from '@mui/material';
import StyledModal from '../Components/GenericModal/StyledModal';
import { FormTextField } from '../Components/CustomUIElements/FormTextField';
import ModalFooterButtons from '../Components/GenericModal/ModalFooterButtons';

export default function NewJobTemplateModal({
  isOpen,
  handleClose
}: {
  isOpen: boolean;
  handleClose: () => void;
}) {
  const [templateName, setTemplateName] = useState<string>('');

  return (
    <StyledModal
      isOpen={isOpen}
      label="new-job-template"
      handleClose={handleClose}
      styleOverrides={{
        height: 'auto',
        width: '600px',
        padding: '40px'
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          rowGap: 3
        }}
      >
        <Stack
          sx={{
            fontWeight: 'bold',
            color: '#084D6D',
            fontSize: '25px'
          }}
        >
          New Job Template
        </Stack>
        <FormTextField
          label="Template name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          required
          styles={{ width: '65%', marginBottom: 5 }}
        />
        <ModalFooterButtons
          primaryButtonText="Create"
          primaryButtonCallback={() => console.log('create')}
          secondaryButtonText="Cancel"
          secondaryButtonCallback={handleClose}
          primaryButtonMinWidth="95px"
        />
      </Stack>
    </StyledModal>
  );
}
